<cap-header [welcomePage]="'/home/dashboard'" alt="Logo" appLogo="{{ imagePath }}" appTitleKey="layouts.page.title">
  <li>
    <cap-user-picker [isICP]="true"></cap-user-picker>
  </li>
</cap-header>

<div class="bsg-content-wrapper">
  <nav [attr.aria-label]="'layouts.page.titleNavigation' | translate" id="navigation">
    <cap-environment-marker></cap-environment-marker>
    <cap-bsg-nav-menu class="nav-menu" [ngClass]="{'environment-marker': environmentName}">
      @for (item of root?.children; track item) {
        <cap-bsg-nav-item
          [deactivated]="item.deactivated"
          [href]="item.content.href"
          [icon]="item.content.icon"
          [labelKey]="item.content.text"
          [style]="item.content.style"
          [target]="item.content.target"
          [tooltipKey]="item.content.text"
          [url]="item.content.link">
          @for (item2 of item?.children; track item2) {
            <cap-bsg-nav-item
              [deactivated]="item2.deactivated"
              [href]="item2.content.href"
              [icon]="item2.content.icon"
              [labelKey]="item2.content.text"
              [style]="item2.content.style"
              [target]="item2.content.target"
              [tooltipKey]="item2.content.text"
              [url]="item2.content.link">
            </cap-bsg-nav-item>
          }
        </cap-bsg-nav-item>
      }
    </cap-bsg-nav-menu>
  </nav>

  <main [ngStyle]="showSearchbar ? { 'padding-top': '140px' } : ''" id="content" role="main">
    <cap-alert-list id="alert-wrapper"></cap-alert-list>
    @if (showSearchbar) {
      <form>
        <cap-search-bar [disabled]="disableSearchbar"></cap-search-bar>
      </form>
    }
    <router-outlet></router-outlet>
  </main>
</div>
